import React from 'react';

export default function Footer() {
    return (
        <>
            <div id= "footer"> Copyright, Pancakes. 2022</div>

        </>
        );

};

